import React, { useEffect, useState } from "react";
import { List, X } from "@phosphor-icons/react";
import { LOGO_URL } from "./assets";

const links = [
  { label: "Konfigurátor", href: "#configurator" },
  { label: "Előnyök", href: "#usp" },
  { label: "Referenciák", href: "#references" },
  { label: "Ajánlatkérés", href: "#quote" },
  { label: "Chatbot", href: "#chatbot" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 glass-nav transition-all ${
        scrolled ? "border-b border-[#E4E4E7]" : ""
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a href="#top" data-testid="nav-logo" className="flex items-center gap-2.5">
            <img src={LOGO_URL} alt="Rapidgarázs" className="h-8 md:h-10 w-auto object-contain" />
            <span className="font-display font-black text-lg md:text-xl tracking-tight text-[#0F0F0F]">
              Rapidgarázs
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-8">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.href.replace('#','')}`}
                className="text-sm font-medium text-[#0F0F0F] hover:text-[#0F0F0F] transition-colors"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-2">
            <a href="#callback" data-testid="nav-callback-btn" className="cta-secondary text-sm">
              Visszahívás
            </a>
            <a href="#quote" data-testid="nav-quote-btn" className="cta-primary text-sm">
              Árajánlatot kérek
            </a>
          </div>

          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen(!open)}
            className="md:hidden p-2"
            aria-label="Menü"
          >
            {open ? <X size={24} /> : <List size={24} />}
          </button>
        </div>

        {open && (
          <div className="md:hidden pb-4 border-t border-[#E4E4E7] pt-4 flex flex-col gap-3">
            {links.map((l) => (
              <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="text-sm font-medium text-[#0F0F0F]">
                {l.label}
              </a>
            ))}
            <div className="flex gap-2 pt-2">
              <a href="#callback" onClick={() => setOpen(false)} className="cta-secondary flex-1 justify-center text-sm">
                Visszahívás
              </a>
              <a href="#quote" onClick={() => setOpen(false)} className="cta-primary flex-1 justify-center text-sm">
                Ajánlat
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
